document.addEventListener("DOMContentLoaded", async () => {
  try {
    const cartThreshold = theme.settings.cartGiftThreshold * 100;

    const isCartPage = window.location.pathname.includes("/cart");
    const selectorPrefix = isCartPage ? "#CartPageForm " : "";

    // DOM Elements
    const cartRecommendations = document.querySelector(
      `${selectorPrefix}.cart__item-row.cart-recommendations`
    );
    const giftProductsSection = document.getElementById("cart-gift");
    const missingAmountElement = document.querySelector(
      `${selectorPrefix}#missing-amount`
    );

    if (!giftProductsSection) {
      return;
    }

    // Fetch the live cart, failing loudly so callers' try/catch can handle it.
    // (cart.js returns 403 on the local `shopify theme dev` server.)
    async function getCart() {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!res.ok) throw new Error(`cart.js returned ${res.status}`);
      return res.json();
    }

    // Event Delegation for Gift Products
    giftProductsSection.addEventListener("click", async (event) => {
      const giftProduct = event.target.closest("[data-gift-product]");
      if (giftProduct?.dataset?.variantId) {
        await addGift(giftProduct.dataset.variantId);
      }
    });

    // ======================
    // VALIDATION / UI UPDATES
    // ======================

    function validateCart(cart) {
      let giftKey = null;
      let nonGiftTotal = 0;
      let preorderActive = false;
      let allowedVariantIds = theme.settings.subscriptionProductVariants.split(",");

      cart.items.forEach((item) => {
        if (item.properties?._minimum_quantity || allowedVariantIds.includes(item.variant_id.toString())) {
          preorderActive = true;
        }
      })

      cart.items.forEach((item) => {
        // Handle pre order exception
        if (item.properties?._isGift && preorderActive) {
          giftKey = item.key;

          removeGift(giftKey);
        } else if (item.properties?._isGift) {
          giftKey = item.key;
          setupRemoveButton(item.key);
        } else {
          nonGiftTotal += item.line_price;
        }
      });

      const giftEligible = nonGiftTotal >= cartThreshold;
      const hasGift = !!giftKey;

      updateMissingAmount(nonGiftTotal);
      updateUIState(giftEligible, hasGift, giftKey, preorderActive);
    }

    function setupRemoveButton(lineKey) {
      // Use a data attribute on the remove button referencing the gift key
      const removeBtn = document.querySelector(`[data-id="${lineKey}"]`);
      removeBtn?.addEventListener("click", async () => {
        await removeGift(lineKey);
        showGifts(true);
      });
    }

    function updateMissingAmount(nonGiftTotal) {
      if (!missingAmountElement) return;
      const missing = Math.max(cartThreshold - nonGiftTotal, 0) / 100;
      missingAmountElement.textContent = missing.toFixed(2);
    }

    function updateUIState(giftEligible, hasGift, giftKey, preorderActive = false) {
      if(preorderActive) {
        if(giftKey) {
          removeGift(giftKey).then(() => {
            hideGifts(false); // Only lock/hide the gifts
          });
        } else {
          hideGifts(false);
        }
      } else if (hasGift && !giftEligible) {
        removeGift(giftKey).then(() => {
          hideGifts(true); // Only lock/hide the gifts
        });
      } else if (giftEligible && !hasGift) {
        showGifts(true); // Unlock
      } else if (!giftEligible) {
        hasGift ? hideGifts() : hideGifts(true);
      } else {
        showGifts(); // Unlock
      }
    }

    // ===============
    // UI CONTROLS
    // ===============
    function showGifts(unlock = false) {
      cartRecommendations?.style.setProperty("display", "none", "important");
      giftProductsSection.style.display = "none";

      if (unlock === true) {
        giftProductsSection.classList.remove("locked");
        giftProductsSection.style.display = "block";
      }
    }

    function hideGifts(lock = false) {
      if (lock) {
        giftProductsSection.classList.add("locked");
        giftProductsSection.style.display = "block";
      } else {
        giftProductsSection.style.display = "none";
      }

      // If completely hiding, restore the recommendations
      if (!lock) {
        cartRecommendations?.style.removeProperty("display");
      }
    }

    // ===============
    // CART ACTIONS
    // ===============
    async function addGift(variantId) {
      try {
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: { _isGift: true },
              },
            ],
          }),
        });
        // Force a fresh fetch of the final cart state
        const updatedCart = await getCart();
        handleCartUpdate(updatedCart);
      } catch (error) {
        console.error("Error adding gift:", error);
      }
    }

    async function removeGift(lineId) {
      try {
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: lineId, quantity: 0 }),
        });
        // Force a fresh fetch of the final cart state
        const updatedCart = await getCart();
        handleCartUpdate(updatedCart);
      } catch (error) {
        console.error("Error removing gift:", error);
      }
    }

    function handleCartUpdate(cart) {
      document.dispatchEvent(new CustomEvent("cart:build"));
      validateCart(cart);
    }

    // ===============
    // EVENT LISTENERS
    // ===============
    document.addEventListener("cart:updated", (e) => {
      validateCart(e.detail.cart);
    });

    // If you have some AJAX-based add-to-cart logic in theme, it might trigger "ajaxProduct:added"
    document.addEventListener("ajaxProduct:added", async () => {
      try {
        const updatedCart = await getCart();
        handleCartUpdate(updatedCart);
      } catch (error) {
        console.error("Error refreshing cart after add:", error);
      }
    });

    // Initial cart fetch/validate (prefer the server-rendered cart to avoid a fetch)
    const initialCart = theme.cartInitial || (await getCart());
    validateCart(initialCart);
  } catch (error) {
    console.error("Cart gift threshold error:", error);
  }
});
